import { Link } from 'react-router-dom';
import LoginForm from '../components/LoginForm';

import './CSS/Login.css';

const Login: React.FC = () => {
    return (
        <div id='LoginPage' className='page'>
            <div id='login-container'>
                <LoginForm></LoginForm>
                <div>
                    <Link to='/join'>登録はこちら</Link>
                </div>
            </div>
        </div>
    );
};

export default Login;
